import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./navbar.css";

import { Link } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";

const Navbar = () => {
  const navigate = useNavigate();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="pvx-navbar">
        <div className="logo">
          <Link to="/">
            <img src="./images/Logos/pvxLogo.svg" alt="logo" />
          </Link>
        </div>
        <div className="nav-links">
          {/* 5 divs for navigations */}
          <div className="nav-link" onClick={() => navigate("/")}>
            Product
          </div>
          <div className="nav-link" onClick={() => navigate("/")}>
            Company
          </div>
          <div className="nav-link" onClick={() => navigate("/pricing")}>
            Pricing
          </div>
          <a href="#ContactUs">
            <div className="nav-link">Contact Us</div>
          </a>
          <div className="nav-link" onClick={() => navigate("/signIn")}>
            PVX SignIn
          </div>
        </div>
        <div className="mobile">
          <div className="nav-btn" onClick={() => navigate("/request-signup")}>
            Request SignUp
          </div>
          <div className="menuIcon" onClick={handleShow}>
            <i className="bi bi-list"></i>
          </div>
        </div>
      </div>
      {/* Move it from right to left */}
      <Offcanvas
        show={show}
        placement="end"
        onHide={handleClose}
        className="pvx-mobile-nav"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img src="../images/PVX/pvx.png" alt="logo"></img>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="homeSideBar">
            <ul>
              <Link to="/bhSmith">
                <li>Product</li>
              </Link>
              <Link to="/bhRenewable">
                <li>Company</li>
              </Link>
              <Link to="/bhRenewable">
                <li>Pricing</li>
              </Link>
              <a href="#ContactUs" onClick={handleClose}>
                <li>Contact Us</li>
              </a>
              <Link to="/signIn">
                <li>Request Sign Up</li>
              </Link>
            </ul>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Navbar;
